import { Link } from 'react-router-dom';
import { format } from 'date-fns';

export default function DocumentsPutCard({id, addressEvent, dateReception, dateSend,
                                        numberDocument, nameCompany }){

     //console.log(id)                                       

    return(
        <div className="">
            <div className="border-b border-slate-500">
            <Link to={`/documentos/modificar/${id}`}>
            <div className="flex text-[11px] hover:font-bold pt-2 text-sky-200 hover:text-orange-400">
                <div className='w-12 text-center'>                    
                    {numberDocument}
                </div>
                <div className='w-60'>                    
                    {nameCompany}
                </div>
                <div className='w-5/12'>                    
                    {addressEvent}
                </div>
                <div className='w-20 pl-2'>                    
                    {dateSend ? format(new Date(dateSend), "dd/MM/yyyy") : null}
                </div>
                <div className='w-20 pl-2'>                    
                    {dateReception ? format(new Date(dateReception), "dd/MM/yyyy") : null}
                </div>
            </div>  
            </Link>
            </div>
        </div>
    )
}